import { reportUncaughtException } from 'src/dataLayer/remoteData/rollbar'

// eslint-disable-next-line unicorn/prefer-add-event-listener -- we need to use onerror for legacy compatibility
globalThis.onerror = () => reportUncaughtException
